/**
 * Parses a single numeric TYPO3-Record ID
 *
 * @return the numeric record id as non-zero, positive, finite number or the literal number 0.
 */
export const parseNumericId = (input: string | number): number =>
  typeof input === 'number' ? input : parseInt(input) || 0;
